/* prettier-ignore */

import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { IDatasource } from 'ngx-ui-scroll';

@Component({
  selector: 'cicerone-list-events',
  templateUrl: './list-events.component.html',
  styleUrls: ['./list-events.component.scss'],
  encapsulation: ViewEncapsulation.None,
  
})

export class ListEventsComponent {
  @Input() events?: any;

    datasource: IDatasource = {
    get: (index, count, success) => {
      const data = [];
      for (let i = index; i <= index + count - 1; i++) {
        if (this.events?.length > i)
          data.push({type: 'item', data: this.events[i]});
        // else if (this.events?.length === i)
        //   data.push({type: 'more', data: []})
      }
      success(data);
    },
    settings: {
      horizontal: true,
      minIndex: 0,
      startIndex: 0
    }
  };

  constructor(private router: Router) {}
  
  goToSubCategoriesList(itemID) {
    this.router.navigate([`/${itemID}`]);
  }

}
